import React, {FC} from 'react';

import {CtaButton} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {setErrorsSuccessPage, changeSuccessScreen} from '../../store/actions/orderItems/orderItems';
import {
    getSuccessPageItemsValidated,
    getErrorMessage,
    getSuccessPageItems,
    isOnlyDoctorDetails,
    getSendByMessage,
} from '../../store/selectors/orderItems/orderItems';
import {getOrderId} from '../../store/selectors/selectors';

import {PropsType, useConfirmButton} from './useConfirmButton/useConfirmButton';

import s from './confirmButton.scss';

/**
 * Displays sticky cta button to confirm your prescription on TYP
 * @constructor
 */
export const ConfirmButton: FC<PropsType> = props => {
    const {onClick, state} = useConfirmButton(props);

    return (
        <div className={s.buttonContainer}>
            <CtaButton
                className={s.btn}
                isLoading={state.isLoading}
                onClick={onClick}
                size="medium"
            >
                Confirm
            </CtaButton>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    hasOnlyDoctorDetails: isOnlyDoctorDetails(store),
    items: getSuccessPageItems(store),
    label: getSendByMessage(store),
    message: getErrorMessage(store),
    orderId: getOrderId(store),
    successPageItemsValidated: getSuccessPageItemsValidated(store),
});

export const ConfirmButtonConnected = connect(mapStateToProps, {
    changeScreen: changeSuccessScreen,
    setErrors: setErrorsSuccessPage,
})(ConfirmButton);
